import * as React from 'react';
import {ParametersControl} from './ParametersControl';

export const InternalParametersControl = () => {
    return <ParametersControl internal={true} />;
};
